// eslint-disable-next-line
// @ts-nocheck
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
// material
import {
  Card,
  Table,
  Stack,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
} from '@mui/material';
// components
import Page from '../../components/Page';
import Scrollbar from '../../components/Scrollbar';
import SearchNotFound from '../../components/SearchNotFound';
import { BookingListToolbar } from '../../sections/@dashboard/bookings';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import AllParkingsListHead from '../../sections/@dashboard/bookings/AllParkingsListHead';
import Loading from '../../components/Loading';

// mock
// import USERLIST from '../_mock/user';
import { useFindAllMutation } from '../../store/api/walletManagementApi';
import {
  getWalletManagement,
  getWalletManagementTotalRecord,
  setWalletManagement,
} from '../../store/state/walletManagementSlice';
import { fDateTimeSuffix } from '../../utils/formatTime';
// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'name', label: 'Username', alignRight: false },
  // { id: 'userId', label: 'User ID', alignRight: false },
  { id: 'date', label: 'Date', alignRight: false },
  { id: 'amount', label: 'Amount', alignRight: false },
  { id: 'opening', label: 'Opening', alignRight: false },
  { id: 'closing', label: 'Closing', alignRight: false },
  { id: 'transactionType', label: 'Transaction Type', alignRight: false },
];

export default function WalletManagement() {
  const navigate = useNavigate();
  const token = JSON.parse(localStorage.getItem('login') || '{}') || null;
  const dispatch = useAppDispatch();
  const [findAll, findAllResponse] = useFindAllMutation();
  const [walletManagementData, setWalletManagementData] = useState([]);
  const walleData = useAppSelector(getWalletManagement);
  const WalletManagementTotalRecord = useAppSelector(getWalletManagementTotalRecord);
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('id');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [value, setValue] = useState(0);
  const [open, setOpen] = useState(false);
  const [name, setName] = useState('');
  const filteredUsers = walletManagementData;
  const isUserNotFound = filteredUsers.length === 0;

  useEffect(() => {
    if (walleData) {
      setWalletManagementData(walleData);
    }
  }, [walleData]);

  useEffect(() => {
    findAll({
      token: token.token,
      payload: {
        offset: rowsPerPage,
        page: page,
        searchValue: name,
      },
    });
  }, []);

  useEffect(() => {
    if (findAllResponse.isSuccess) {
      dispatch(setWalletManagement(findAllResponse.data));
    }
  }, [findAllResponse.isSuccess]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = serviceProviders.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    findAll({
      token: token.token,
      payload: { offset: rowsPerPage, page: newPage },
    });
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    findAll({
      token: token.token,
      payload: { offset: event.target.value, page: 0 },
    });
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
    findAll({
      token: token.token,
      payload: { offset: rowsPerPage, page: page, searchValue: event.target.value },
    });
  };

  return (
    <Page title="Wallet Management">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" marginBottom={'25px'}>
          <Typography variant="h4" gutterBottom>
            Wallet Management
          </Typography>
        </Stack>
        <Card>
          <BookingListToolbar numSelected={selected.length} filterName={filterName} onFilterName={handleFilterByName} />
          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <AllParkingsListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={walletManagementData.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {filteredUsers.length > 0 &&
                    filteredUsers.map((row) => {
                      const {
                        id,
                        customerName,
                        userId,
                        createdDate,
                        transactionAmount,
                        openingAmount,
                        closingAmount,
                        status,
                        transactionType,
                      } = row;
                      const isItemSelected = selected.indexOf(name) !== -1;

                      return (
                        <TableRow
                          hover
                          key={id.toString()}
                          tabIndex={-1}
                          role="checkbox"
                          selected={isItemSelected}
                          aria-checked={isItemSelected}
                        >
                          <TableCell align="left">
                            <Typography fontWeight="bold" variant="subtitle2">
                              {customerName}
                            </Typography>
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontWeight="bold" variant="subtitle2">
                              {fDateTimeSuffix(createdDate)}
                            </Typography>
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontWeight="bold" variant="subtitle2">
                              {transactionAmount}
                            </Typography>
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontWeight="bold" variant="subtitle2">
                              {openingAmount}
                            </Typography>
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontWeight="bold" variant="subtitle2">
                              {closingAmount}
                            </Typography>
                          </TableCell>
                          <TableCell align="left">
                            <Typography fontWeight="bold" variant="subtitle2">
                              {transactionType}
                            </Typography>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>

                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filterName} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={WalletManagementTotalRecord || 0}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
        {walletManagementData.isLoading ? (
          // || deleteResponse.isLoading
          <Loading />
        ) : null}
      </Container>
    </Page>
  );
}
